/* eslint-disable no-template-curly-in-string */
import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
// import { Message } from 'element-ui'
// import Layout from './views/layout/Layout'

const whiteList = ['/login'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  NProgress.start()
  // console.log(to.path)
  if (store.getters.token) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not triggerafterEach hook, so manually handle it
    } else {
      // if (to.path.indexOf('/stations') === 0) {
      //   console.log('full-path' + to.fullPath)
      //   if (store.getters.routeState === false) {
      //     console.log('enter /stations')
      //     const devices = store.getters.devices
      //     devices.forEach((element) => {
      //       const route = {
      //         path: `${element.devid}`,
      //         name: 'station' + element.devid,
      //         component: () => import('@/views/tree/index'),
      //         meta: { title: element.name },
      //         props: true
      //       }
      //       store.dispatch('addRoute', route)
      //     })
      //     router.options.routes = store.getters.routes
      //     // 替换现有router的routes
      //     router.addRoutes(store.getters.routes)
      //     store.dispatch('setRouteState', true)
      //     next()
      //   } else {
      //     next()
      //   }
      // } else {
      //   next()
      // }
      // if (store.getters.roles.length === 0) {
      //   store
      //     .dispatch('GetInfo')
      //     .then((res) => {
      //       // 拉取用户信息
      //       next()
      //     })
      //     .catch((err) => {
      //       store.dispatch('FedLogOut').then(() => {
      //         Message.error(err || 'Verification failed, please login again')
      //         next({ path: '/' })
      //       })
      //     })
      // } else {
      //   next()
      // }
      next()
      NProgress.done()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
